import { useEffect, useRef } from 'react';

import { Toasty, useAtomsToastManager } from '@opendoor/atoms/toast';
import { ImpersonationBanner as SharedImpersonationBanner } from '@opendoor/auth-fe/impersonation-banner';
import { useImpersonationSnapshot } from '@opendoor/auth-fe/impersonation-state';

import { CUSTOMER_ACTION_BLOCKED_MESSAGE, impersonationSession } from './impersonation';

const BlockedActionToast = () => {
  const { lastBlocked, writeModeEnabled } = useImpersonationSnapshot(impersonationSession);
  const toastManager = useAtomsToastManager();
  const toastManagerRef = useRef(toastManager);
  const reported = useRef(0);

  useEffect(() => {
    toastManagerRef.current = toastManager;
  }, [toastManager]);

  useEffect(() => {
    if (!lastBlocked || lastBlocked.count === reported.current) return;
    reported.current = lastBlocked.count;
    toastManagerRef.current.add({
      id: 'cosmos-impersonation-action-blocked',
      variant: 'error',
      title: writeModeEnabled
        ? CUSTOMER_ACTION_BLOCKED_MESSAGE
        : 'This action was not saved. Turn on Write mode to make changes.',
      timeout: 5_000,
    });
  }, [lastBlocked, writeModeEnabled]);

  return null;
};

export const ImpersonationBanner = () => {
  const { customerUUID } = useImpersonationSnapshot(impersonationSession);
  if (!customerUUID) return null;

  return (
    <>
      <SharedImpersonationBanner session={impersonationSession} />
      <Toasty>
        <BlockedActionToast />
      </Toasty>
    </>
  );
};
